module.exports = __webpack_public_path__ + "media/src/fonts/Lora-Bold-e41abf31679dc075e8aa75fa71828bd3.woff";